module.exports = __webpack_public_path__ + "static/media/14. Transparencia2, Resina Cristal Dos piezas, 133 x 100 x 14 cm cada una, 2019 copy.fc2ef132.png";